import React, { useEffect } from 'react';
import 'react-data-grid/lib/styles.css';
import { Card, CardBody, Col, Container, FormGroup, Row } from 'reactstrap';

export default function WSRBDetailViewOptions() {

    const detailFields = [
        { id: "1", value: "Activity" },
        { id: "2", value: "Type" },
        { id: "3", value: "Training Hours" },
        { id: "4", value: "Completion Date" },
        { id: "5", value: "Start Time" },
        { id: "6", value: "End Time" },
        { id: "7", value: "Status" },
        { id: "8", value: "WSRB Category" },
        { id: "9", value: "Additional Topic Description" },
        { id: "10", value: "Score" },
        { id: "11", value: "Location" },
        { id: "12", value: "Description" },
        { id: "13", value: "Internal Instructors" },
        { id: "14", value: "External Instructors" },
        { id: "15", value: "Department" },
        { id: "16", value: "Personnel ID" },
        { id: "17", value: "Rank" },
        { id: "18", value: "Shift" },
        { id: "19", value: "Station" },
        { id: "20", value: "Division" },
        { id: "21", value: "Battalion" },
        { id: "22", value: "Company" },
        { id: "23", value: "Platoon" },
        { id: "24", value: "Bureau" },
        { id: "25", value: "EMS Certification" },
    ];

    return(
    <Container>
        <h1>Report Fields</h1>
        <FormGroup>
            <Card>
                <CardBody>
                    <Row>
                        <Col xs="6">
                            <h5>Detail Fields</h5>
                        </Col>
                        <Col xs="6">
                            {detailFields.map((item, index) => {
                                return (
                                    <div key={item.id} className="checkbox-container">
                                        <label>
                                            <input
                                                type="checkbox"
                                                name="options"
                                                value={item.value}
                                                defaultChecked = {true}
                                                disabled = {true}
                                            />
                                            &nbsp;{item.value}
                                        </label>
                                    </div>
                                );
                            })}
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </FormGroup>
    </Container>
    );
}
